import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export const downloadFileByURL = ({ url, fileName }) => {
  if (!url) {
    return null;
  }

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// `url` should be served with `Content-Disposition: attachment` (e.g. a rescue photo's `download_url`, a presigned S3
// URL signed for downloading). Browsers ignore the `download` attribute on cross-origin links, but they save an
// attachment response instead of navigating to it, so the user stays on the page.
export const downloadRemoteFile = ({ url, fileName }) => {
  if (!url) {
    return null;
  }

  // the WebView of the native app would navigate away from the app, open the file in the in-app browser instead
  if (Capacitor.isNativePlatform()) {
    return Browser.open({ url });
  }

  return downloadFileByURL({ url, fileName });
};
